import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import CustomAutoCompleteProductKey from "../../../../../components/formik/CustomAutoCompleteProductKey";
import CustomAutoCompleteUnitKey from "../../../../../components/formik/CustomAutoCompleteUnitKey";

const TypeServiceFields = ({
  values,
  handleChange,
  selectedProductKey,
  setSelectedProductKey,
  selectedUnitKey,
  setSelectedUnitKey,
  touched,
  errors,
}) => {
  const [autoCompleteKey, setAutoCompleteKey] = useState(0);

  return (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="type_service_name">
            <Form.Label>Nombre del Tipo de servicio</Form.Label>
            <Form.Control
              type="text"
              name="type_service_name"
              placeholder="Nombre del Tipo de servicio"
              value={values.type_service_name}
              onChange={handleChange}
              isInvalid={!!errors.type_service_name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.type_service_name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <CustomAutoCompleteProductKey
            key={autoCompleteKey}
            widthClass="w-100"
            formik={{
              values: { productKey: selectedProductKey },
              setFieldValue: (field, value) => {
                if (field === "productKey") {
                  setSelectedProductKey(value);
                }
              },
              touched,
              errors,
            }}
            field="productKey"
            labelAlign="left"
          />
        </Col>
         <Col md={6}>
          <CustomAutoCompleteUnitKey
            key={autoCompleteKey}
            widthClass="w-100"
            formik={{
              values: { unitKey: selectedUnitKey },
              setFieldValue: (field, value) => {
                if (field === "unitKey") {
                  setSelectedUnitKey(value);
                }
              },
              touched,
              errors,
            }}
            field="unitKey"
            labelAlign="left"
          />
        </Col>
      </Row>
    </>
  );
};

export default TypeServiceFields;
